import { cn } from "@eisox/design-system";

import { Tooltip } from "~/components/tooltip";
import { m } from "~/paraglide/messages";

import { Position, type Component } from "../types";
import { Card } from "./card";

interface PressureSwitchProps extends Component {
  defect: boolean;
}

// The bracket spans its parent, so this only belongs inside a component it brackets (fan, filter).
// Straight in a duct it claims the whole lane width — use `Indicator` there.
const PressureSwitch: React.FC<PressureSwitchProps> = ({ defect, position = Position.TOP }) => (
  <div className="relative flex w-full flex-col items-center">
    <Tooltip content={m.pressure_switch()}>
      <Card defect={defect} position={position}>
        P
      </Card>
    </Tooltip>
    <div
      className={cn(
        "h-12.5 absolute z-[-1] w-full border-t-2 border-r-2 border-l-2 border-primary-dark-blue",
        position === Position.TOP && "top-1/2",
        position === Position.BOTTOM && "bottom-1/2 transform-[scaleY(-1)]",
      )}
    />
  </div>
);

PressureSwitch.displayName = "ComponentPressureSwitch";

export { PressureSwitch };
export type { PressureSwitchProps };
